import * as React from 'react';
import {createContext, PropsWithChildren, useCallback, useContext, useMemo, useState} from 'react';
import {useActivateListener} from '@variocube/cube-ui';
import {LauncherItem} from '@variocube/app-api';

export interface DialogMessage {
    title: string;
    message: string;
    confirm?: () => void;
    cancel?: () => void;
    disableAutoClose?: boolean;
}

interface DialogMessageContext {
    message?: DialogMessage;
    setMessage: (message?: DialogMessage) => void;
}

const DIALOG_MESSAGE_CONTEXT = createContext<DialogMessageContext | undefined>(undefined);

export function DialogMessageProvider({children}: PropsWithChildren<{}>) {
    const [message, setMessage] = useState<DialogMessage>();

    const handleActivate = useCallback((item?: LauncherItem) => {
        setMessage(undefined);
    }, []);
    useActivateListener(handleActivate);


    const contextValue = useMemo(() => ({
        message,
        setMessage,
    }), [message, setMessage]);

    return (
        <DIALOG_MESSAGE_CONTEXT.Provider value={contextValue}>
            {children}
        </DIALOG_MESSAGE_CONTEXT.Provider>
    );
}

export function useDialogMessageContext() {
    const context = useContext(DIALOG_MESSAGE_CONTEXT);
    if (!context) {
        throw new Error("No dialog message context found. Are you missing DialogMessageProvider in your component tree?");
    }
    return context;
}

export function useMessage() {
    return useDialogMessageContext().message;
}

export function useSetMessage() {
    return useDialogMessageContext().setMessage;
}